import React, { useMemo } from "react";
import styled, { css } from "styled-components";

const StyledProgressSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;

  padding-top: 7px;
  padding-bottom: 7px;

  background-color: #eaeaea;

  .progress-bar-container {
    display: flex;
    justify-content: space-between;
    align-items: center;

    width: 980px;

    padding-left: 15px;
    padding-right: 15px;

    .progress-bar-title {
      font-family: 'RobotoBold';
      font-size: 12px;
      line-height: calc(1.42857rem * (12 / 16));
      text-transform: uppercase;
    }

    .progress-bar-desktop-steps {
      display: flex;
      font-family: 'RobotoBold';
      font-size: 12px;
      line-height: calc(1.42857rem * (12 / 16));
      text-transform: uppercase;
    }

    .progress-bar-mobile-steps {
      font-family: 'RobotoRegular';
      font-size: 13px;
      line-height: calc(1.42857rem * (13 / 16));
      opacity: 0.6;
    }
  }

  @media ${({ theme }) => theme.devices.laptopS} {
    .progress-bar-container {
      width: 720px;
    } 
  }

  @media ${({ theme }) => theme.devices.tablet} {
    .progress-bar-container {
      width: 100%;
    } 
  }
`;

const StyledStep = styled.div`
  margin-left: 40px;

  ${({ active }) => active && css`
    &:before {
      display: inline-block;
      padding-right: 7px;
      vertical-align: sub;
      content: '\\00BB';
      line-height: 0px;
      font-size: 26px;
    }
  `}
`;

function ProgressSection({ mobile, currentStep, steps = [], currentSubStep, maxSubStep }) {
  const activeTitle = useMemo(() => steps.find(({ step }) => step === currentStep)?.title, [steps, currentStep]);

  return (
    <StyledProgressSection>
      <div className="progress-bar-container">
        <div className="progress-bar-title">
          {!mobile && (<span>EIN NUMBER APPLICATION PROGRESS</span>)}
          {mobile && (<span>{activeTitle}</span>)}
        </div>
        {!mobile && (
          <div className="progress-bar-desktop-steps">
            {steps.map(({ step, title }) => (
              <StyledStep key={step} active={step === currentStep}>
                <span>{title}</span>
              </StyledStep>
            ))}
          </div>
        )}
        {mobile && currentSubStep && (
          <div className="progress-bar-mobile-steps">
            <span>{`Step ${currentSubStep} of ${maxSubStep}`}</span>
          </div>
        )}
      </div>
    </StyledProgressSection>
  );
}

export default ProgressSection;
